import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { TextEditor } from '../../../../../components/TextEditor'

export const Descricao = () => {
  const { control } = useFormContext()

  return (
    <Flex flexDir={'column'} gap={5}>
      <Text fontSize="23px" fontWeight="bold">
        Descrição
      </Text>
      <Controller
        name={`secao_principal.descricao`}
        control={control}
        render={({ field }) => <TextEditor height="100px" name={`secao_principal.descricao`} {...field} placeholder="Resposta" />}
      />
    </Flex>
  )
}
